module.exports = __webpack_public_path__ + "static/media/not-say-active.8956440b.svg";